/* Strade fixes: instant colour image switch, image preloading, zoom panning.
   Loaded right after aldo.js from sections/aldo-core.liquid. No dependencies. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- product page: show the colour's photo the moment a swatch is picked ---------- */
  // aldo.js only moves the gallery once a full variant is chosen, so with "Shopper must pick a size"
  // on, picking a colour did nothing until a size was tapped, then scrolled slowly. This runs first.
  function variants(el) {
    if (el._stV) return el._stV;
    var d = el.querySelector('[data-st-variants]');
    try { el._stV = d ? JSON.parse(d.textContent) : []; } catch (e) { el._stV = []; }
    return el._stV;
  }
  function sizeIndex(el) {
    var p = el.querySelector('[data-st-picker]');
    return p ? parseInt(p.getAttribute('data-size-index'), 10) : -1;
  }
  function selectedValues(el, count) {
    var out = [];
    for (var i = 0; i < count; i++) {
      var c = el.querySelector('input[data-opt="' + i + '"]:checked');
      var s = el.querySelector('select[data-opt="' + i + '"]');
      out.push(c ? c.value : (s ? s.value : null));
    }
    return out;
  }
  function mediaForSelection(el) {
    var vs = variants(el);
    if (!vs.length) return null;
    var si = sizeIndex(el);
    var sel = selectedValues(el, vs[0].options.length);
    var fallback = null;
    for (var k = 0; k < vs.length; k++) {
      var v = vs[k];
      if (!v.featured_media) continue;
      var ok = v.options.every(function (o, i) { return i === si || sel[i] == null || o === sel[i]; });
      if (!ok) continue;
      if (si < 0 || sel[si] == null || v.options[si] === sel[si]) return v.featured_media.id;
      if (!fallback) fallback = v.featured_media.id;
    }
    return fallback;
  }
  function flash(item) {
    if (reduceMotion) return;
    item.classList.remove('is-swap');
    void item.offsetWidth;
    item.classList.add('is-swap');
  }
  function showMedia(el, mediaId) {
    var gallery = el.querySelector('[data-st-gallery]');
    var track = gallery && gallery.querySelector('.st-gal__track');
    var item = track && track.querySelector('[data-media-id="' + mediaId + '"]');
    if (!item) return;
    var img = item.querySelector('img');
    if (img) { img.loading = 'eager'; try { img.fetchPriority = 'high'; } catch (e) {} }
    var isSlider = getComputedStyle(track).display === 'grid' && track.scrollWidth > track.clientWidth + 4;
    if (isSlider) {
      var x = item.offsetLeft - track.offsetLeft;
      if (Math.abs(track.scrollLeft - x) < 2) return;
      // jump straight there: smooth scrolling across a snapping slider is what felt slow on phones
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = x;
      requestAnimationFrame(function () { track.style.scrollSnapType = ''; track.style.scrollBehavior = ''; });
      flash(item);
      track.dispatchEvent(new Event('scroll'));
    } else if (gallery.getAttribute('data-move-first') === 'true') {
      if (item !== track.firstElementChild) { track.insertBefore(item, track.firstElementChild); flash(item); }
      if (item.getBoundingClientRect().top < 0) item.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  }
  // capture phase: runs before aldo.js's own change handler on the product section
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-opt]')) return;
    var el = input.closest('[data-st-product]');
    if (!el) return;
    if (parseInt(input.getAttribute('data-opt'), 10) === sizeIndex(el)) return;
    var id = mediaForSelection(el);
    if (id) showMedia(el, id);
  }, true);

  // load every colour's main photo in the background so switching never waits on the network
  function preloadColourImages() {
    $$('[data-st-product]').forEach(function (el) {
      var seen = {};
      variants(el).forEach(function (v) {
        if (!v.featured_media || seen[v.featured_media.id]) return;
        seen[v.featured_media.id] = true;
        var img = el.querySelector('[data-media-id="' + v.featured_media.id + '"] img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      });
    });
  }
  function whenIdle(fn) {
    var run = function () { ('requestIdleCallback' in window) ? requestIdleCallback(fn, { timeout: 2500 }) : setTimeout(fn, 600); };
    if (document.readyState === 'complete') run(); else window.addEventListener('load', run, { once: true });
  }
  whenIdle(preloadColourImages);
  document.addEventListener('shopify:section:load', function () { whenIdle(preloadColourImages); });
  // hovering or touching a swatch starts that photo straight away
  ['pointerover', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var sw = e.target.closest && e.target.closest('.st-optsw');
      if (!sw) return;
      var el = sw.closest('[data-st-product]');
      var input = sw.querySelector('input[data-opt]');
      if (!el || !input) return;
      var oi = parseInt(input.getAttribute('data-opt'), 10);
      variants(el).some(function (v) {
        if (v.options[oi] !== input.value || !v.featured_media) return false;
        var img = el.querySelector('[data-media-id="' + v.featured_media.id + '"] img');
        if (img) img.loading = 'eager';
        return true;
      });
    }, { passive: true });
  });

  /* ---------- product cards: warm the swatch photos before they are shown ---------- */
  function warmCard(card) {
    if (!card || card._stWarm) return;
    card._stWarm = true;
    $$('[data-swatch-img]', card).forEach(function (sw) { var i = new Image(); i.decoding = 'async'; i.src = sw.getAttribute('data-swatch-img'); });
  }
  document.addEventListener('pointerover', function (e) { if (e.target.closest) warmCard(e.target.closest('.st-card')); }, { passive: true });
  document.addEventListener('touchstart', function (e) { if (e.target.closest) warmCard(e.target.closest('.st-card')); }, { passive: true });

  /* ---------- full-screen image preview: zoom where tapped, pan to every edge ---------- */
  var zoomAt = null;
  document.addEventListener('click', function (e) {
    var slide = e.target.closest && e.target.closest('.st-zoom__slide');
    if (!slide || e.target.tagName !== 'IMG') { zoomAt = null; return; }
    var r = e.target.getBoundingClientRect();
    zoomAt = { slide: slide, x: (e.clientX - r.left) / (r.width || 1), y: (e.clientY - r.top) / (r.height || 1) };
  }, true);
  document.addEventListener('click', function () {
    var p = zoomAt;
    zoomAt = null;
    if (!p || !p.slide.classList.contains('is-zoomed')) return;
    requestAnimationFrame(function () {
      var img = p.slide.querySelector('img');
      if (!img) return;
      p.slide.scrollLeft = img.offsetLeft + p.x * img.offsetWidth - p.slide.clientWidth / 2;
      p.slide.scrollTop = img.offsetTop + p.y * img.offsetHeight - p.slide.clientHeight / 2;
    });
  });
})();
